type McpServerDisplaySource = {
  name: string;
  url?: string | null;
};

function titleCase(value: string): string {
  return value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

function parseUrl(value: string | null | undefined): URL | null {
  if (!value) return null;
  try {
    return new URL(value);
  } catch {
    return null;
  }
}

function getNameFromUrl(value: string | null | undefined): string | null {
  const parsed = parseUrl(value);
  if (!parsed) return null;

  const parts = parsed.hostname
    .replace(/^www\./, '')
    .split('.')
    .filter((part) => part && part !== 'mcp' && part !== 'app');
  const candidate = parts[0];
  return candidate ? titleCase(candidate) : null;
}

export function getMcpServerDisplayName(
  server: McpServerDisplaySource,
): string {
  const trimmedName = server.name.trim();
  if (!parseUrl(trimmedName)) return trimmedName;
  return (
    getNameFromUrl(server.url) ?? getNameFromUrl(trimmedName) ?? trimmedName
  );
}
